exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sk-spinner-pulse {\n    position: relative;\n    top: 50%;\n    width: 40px;\n    height: 40px;\n    margin: auto;\n    border-radius: 100%;\n    animation: sk-pulseScaleOut 1s infinite ease-in-out;\n}\n\n@keyframes sk-pulseScaleOut {\n    0% {\n        transform: scale(0);\n    }\n    100% {\n        transform: scale(1);\n        opacity: 0;\n    }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Projects/Yahoo/Server API/ServerAPI/AdminAngular/src/app/spinner/spinkit-css/sk-spinner-pulse.css
// module id = ../../../../../src/app/spinner/spinkit-css/sk-spinner-pulse.css
// module chunks = main